
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
/*Components*/
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';
import EditModal from '../../components/modals/editModal';
import Textarea from '../../components/formComponents/textarea';
import ImageUploader from '../../services/upload/imageUploader';

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';
import Input from '../../components/formComponents/input';
import LazyLoaderGif from '../../components/common/lazyloader';

/*Assets*/
import vendorLogo from '../../assets/images/vendor-logo.jpg';
import ChangeLocationModal from '../../components/modals/changeLocationModal';


class ProfileListing  extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: null,
      apiLoading: true,
      tab: 1,
      category_ids: [],
      selectedSubCatIds: [],
      selectedprod: [],
      subcategoryLoading: false,
      company: "",
      website: "",
      name: "",
      locality: "",
      address: "",
      logo: "",
      locations: []
    }
  }

  async getLocations(){
    let url = devconfig.vendor+"location/list";
    let response = await APIGet(url);
    if(response && response.status=="ok"){
      let locations =[];
      if(response.data && response.data.length){
        response.data.forEach(item=>{
          locations.push({value: item.id, label: item.name});
        });
      }
      this.setState({locations})
    }
  }

  componentDidMount() {
    if(localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1){
      this.setState({localVendor: true});
      this.getLocations();
      this.getDepartments();
    }
    else{
      this.getCategory();
    }
    
  }

  getCategory(){
    var url = devconfig.vendor+'category/all-list';
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        this.setState({ categories: response.data});
        this.getData();
      }
      else {
        this.setState({apiLoading: false});
      }
    }.bind(this))
  }

  getDepartments(){
    var url = devconfig.vendor+'department/list';
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        this.setState({ categories: response.data});
        this.getData();
      }
      else {
        this.setState({apiLoading: false});
      }
    }.bind(this))
  }

  getData(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'auth/profile';
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        if(this.state.localVendor){
          this.setState({ 
            data: response.data, 
            apiLoading: false, 
            category_ids: response.data.department_ids,
            selectedSubCatIds: response.data.category_ids? response.data.category_ids: [],
            selectedprod: response.data.sub_category_ids? response.data.sub_category_ids: [],
            logo: response.data.logo,
            website: response.data.website,
            company: response.data.company,
            name: response.data.name,
            locality: response.data.location,
            address: response.data.address
          });
          if(response.data.department_ids && response.data.department_ids.length)this.getSubCategoryData(response.data.department_ids);
          if(response.data.category_ids && response.data.category_ids.length)this.productAPI(response.data.category_ids);
          if(!response.data.profile_completed) this.setState({tab: 2});
        }
        else{
          this.setState({ 
            data: response.data, 
            apiLoading: false, 
            category_ids: response.data.category_ids,
            selectedSubCatIds: response.data.sub_category_ids? response.data.sub_category_ids: [],
            selectedprod: response.data.product_ids,
            logo: response.data.logo,
            website: response.data.website,
            company: response.data.company,
            name: response.data.name,
            locality: response.data.location,
            address: response.data.address
          });
          if(response.data.category_ids && response.data.category_ids.length)this.getSubCategoryData(response.data.category_ids);
          if(response.data.sub_category_ids && response.data.sub_category_ids.length)this.productAPI(response.data.sub_category_ids);
          if(!response.data.profile_completed) this.setState({tab: 2});
        }
      }
      else{
        this.setState({apiLoading: false});
      }
    }.bind(this))
  }


  async uploadSucess(url, data){
    this.setState({logo:url})
  }
  async uploadStatus(status){
    this.setState({uploading: status})
  }
  chooseImage(){
    $("#e-dp-uploader").click();
  }

  async profileCompleted(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'auth/edit-profile';
    var data = JSON.stringify({
      "company": this.state.company,
      "name": this.state.name,
      "logo": this.state.logo,
      "website": this.state.website,
      "sub_category_ids": this.state.selectedSubCatIds,
      "product_ids": this.state.selectedprod,
      "address": this.state.address,
      "location": this.state.locality,
      "category_ids": this.state.category_ids,
      "seller_type_id": this.state.data.seller_type,
      "document_url": this.state.data.document_url,
      "gst_no": this.state.data.gst_no,
      "mobile": this.state.data.mobile,
      "email": this.state.data.email,
    });
    if(this.state.localVendor){
      data = JSON.stringify({
        "company": this.state.company,
        "name": this.state.name,
        "logo": this.state.logo,
        "website": this.state.website,
        "category_ids": this.state.selectedSubCatIds,
        "sub_category_ids": this.state.selectedprod,
        "address": this.state.address,
        "location": this.state.locality,
        "department_ids": this.state.category_ids,
        "seller_type_id": this.state.data.seller_type,
        "document_url": this.state.data.document_url,
        "gst_no": this.state.data.gst_no,
        "mobile": this.state.data.mobile,
        "email": this.state.data.email,
      });
    }
    await APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        window.location.reload();
      }
    }.bind(this))
  }

  async updateLocation(location){
    this.setState({apiLoading: true});
    let url = devconfig.vendor+ 'auth/edit-profile';
    let  data = JSON.stringify({
        "company": this.state.company,
        "name": this.state.name,
        "logo": this.state.logo,
        "website": this.state.website,
        "category_ids": this.state.selectedSubCatIds,
        "sub_category_ids": this.state.selectedprod,
        "address": this.state.address,
        "location": location.label,
        "location_id": location.value,
        "department_ids": this.state.category_ids,
        "seller_type_id": this.state.data.seller_type,
        "document_url": this.state.data.document_url,
        "gst_no": this.state.data.gst_no,
        "mobile": this.state.data.mobile,
        "email": this.state.data.email,
      });
    await APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        window.location.reload();
      }
      else {
        $("#changeLocationModal").modal("hide");
      }
    }.bind(this))
  }


  productSelect(tempId){
    var tempSubCatIds = this.state.selectedprod;
    var index = tempSubCatIds.indexOf(tempId);
    if( index === -1){
      tempSubCatIds.push(tempId);
      this.setState({selectedprod: tempSubCatIds});
    }
    else{
      var tempVal = $.grep(tempSubCatIds, function(value) {
        return value != tempId;
      });
      this.setState({selectedprod: tempVal})
    }
  }

  subcategoryChange(category_ids){
    var tempCatIds = this.state.category_ids? this.state.category_ids : [];
    var index = tempCatIds.indexOf(category_ids);
    if( index === -1){
      tempCatIds.push(category_ids);
      this.setState({category_ids: tempCatIds});
      this.getSubCategoryData(tempCatIds);
    }else{
      var tempVal = $.grep(tempCatIds, function(value) {
        return value != category_ids;
      });
      this.setState({category_ids: tempVal})
      this.getSubCategoryData(tempVal);
    }
  }

  getSubCategoryData(category_ids){
   if(!this.state.localVendor){
    this.setState({subcategoryLoading: true});
    var url = devconfig.vendor+'subcategory/list';
    var data = JSON.stringify({
      "category_ids": category_ids
    })
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        this.setState({SubCategoryData: response.data, subcategoryLoading: false});
      }
      else{
        this.setState({subcategoryLoading: false});
      }
    }.bind(this))
   }
   else{
     let cat = [];
     let categoryData = [];
     let temp = this.state.categories;
     temp.forEach(department=>{
       if(category_ids.indexOf(department.id)!=-1){
         department.category.forEach(item=>{
           cat.push({id: item.id, sub_category: item.name});
         });
       }
     });
     this.setState({SubCategoryData: cat});
   }
  }

  productChange(sub_category_ids){
    var tempSubCatIds = this.state.selectedSubCatIds;
    var index = -1
    if(tempSubCatIds && tempSubCatIds.length) index = tempSubCatIds.indexOf(sub_category_ids);
    if( index === -1){
      tempSubCatIds.push(sub_category_ids);
      this.setState({selectedSubCatIds: tempSubCatIds});
      this.productAPI(tempSubCatIds);
    }else{
      var tempVal = $.grep(tempSubCatIds, function(value) {
        return value != sub_category_ids;
      });
      this.setState({selectedSubCatIds: tempVal})
      this.productAPI(tempVal);
    }
  }

  productAPI(tempItem){
    if(!this.state.localVendor){
      this.setState({productLoading: true});
    var url = devconfig.vendor+'product/list';
    var data = JSON.stringify({
      "sub_category_ids": tempItem
    })
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        this.setState({productData: response.data, productLoading: false})
      }
      else{
        this.setState({productLoading: false})
      }
    }.bind(this))
    }
    else{
      this.setState({productLoading: true});
    var url = devconfig.vendor+'subcategory/list';
    var data = JSON.stringify({
      "category_ids": tempItem
    })
    APIPost(url, data).then(function(response){
      if(response.status == "ok" && response.data){
        let temp = [];
        response.data.forEach(subcat=>{
          temp.push({id: subcat.id, product: subcat.sub_category});
        })
        this.setState({productData: temp, productLoading: false})
      }
      else{
        this.setState({productLoading: false})
      }
    }.bind(this))
    }
  }

  render() {

    return (
      <div>
      {
        this.state.apiLoading ?
          <APILoader/>
        :
        <div className="e-main-content e-vendor-table e-scheduled-ads-wrap">
          <h2 className="e-page-head">Profile</h2>

          {
            this.state.data ?
              <div>
                <div className="row">
                  {
                    this.state.tab ==  1 ?
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="e-vendor-category-list e-profile-wrap">
                          <div className="row">
                            <div className="col-lg-12">
                                <a className="e-edit" onClick={(e) => this.setState({tab: 2})}>Edit</a>
                            </div>
                          </div>
                          <div className="row e-profile-header no-gutters">
                            <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                              <img src={this.state.data.logo} className="e-profile-logo mr-3" alt="Vendor Logo"/>
                            </div>
                            <div className="col-lg-6 col-md-8 col-sm-8 col-8">
                              <h5 className="mt-3 pt-2">{this.state.data.company}</h5>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-lg-4 col-md-4 col-sm-4 col-6">
                              <h6>Contact Person:</h6>
                              <p>{this.state.data.name}</p>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-6">
                              <h6>Phone:</h6>
                              <p>{this.state.data.mobile}</p>
                            </div>
                            <div className="col-lg-5 col-md-5 col-sm-5 col-6">
                              <h6>Email:</h6>
                              <p>{this.state.data.email}</p>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-6">
                              <h6>Seller Type:</h6>
                              <p>{this.state.data.seller_type_name}</p>
                            </div>
                            <div className="col-lg-7 col-md-7 col-sm-7 col-12">
                              <h6>Website:</h6>
                              <p>{this.state.data.website}</p>
                            </div>
                          </div>
                          <div className="e-vendor-more-details e-border-top pt-3">
                            <div className="row">
                              <div className="col-lg-6">
                                <h6>Locality: </h6>
                                <p>
                                  {this.state.data.location}
                                  {
                                    this.state.localVendor?
                                    <span className="e-edit-location-btn pl-2" data-target="#changeLocationModal" data-toggle="modal">Change Location</span>
                                    :
                                    null
                                  }
                                </p>
                              </div>
                              <div className="col-lg-6">
                                <h6>Address:</h6>
                                <p>{this.state.data.address}</p>
                              </div>
                              <div className="col-lg-6">
                                <h6>GST:</h6>
                                <p>{this.state.data.gst_no}</p>
                              </div>
                              <div className="col-lg-6">
                                <h6>Documents:</h6>
                                <a href={this.state.data.document_url} className="e-documents" target="_blank">View certificate of incorporation</a>
                              </div>
                            </div>
                          </div>
                          <div className="e-vendor-more-details e-border-top pt-3">
                            <div className="row">
                              <div className="col-lg-12">
                                <h6 className="pb-2">Selected Categories:</h6>
                                {
                                  this.state.data && this.state.data.category_data.map((item,index)=> {
                                    return(
                                      <div className="e-column mb-3" key={index}>
                                        <div>
                                          <h6>Category:</h6>
                                          <p className="pb-2 mb-1">{this.state.localVendor? item.department : item.category}</p>
                                        </div>
                                        <div>
                                          <h6>Sub Category:</h6>
                                          {
                                            !this.state.localVendor &&item.sub_category && item.sub_category.map((subItem,index) => {
                                              return(
                                                <span>{(index ? ', ': '') + subItem.sub_category } </span>
                                              );
                                            })
                                          }
                                          {
                                            this.state.localVendor && item.category.map((subItem,index) => {
                                              return(
                                                <span>{(index ? ', ': '') + subItem.category } </span>
                                              );
                                            })
                                          }
                                      </div>
                                      <div>
                                        <h6 className="pt-2">Items/product:</h6>
                                        {
                                          !this.state.localVendor && item.sub_category&& item.sub_category.map((subItem,index) => {
                                            return(
                                              <span>
                                                {
                                                  subItem.product.map((subProduct,index) => {
                                                    return(
                                                      <span className="mb-0">{(index ? ', ': '') + subProduct.product} </span>
                                                    );
                                                  })
                                                }
                                              </span>
                                            );
                                          })
                                        }
                                        {
                                          this.state.localVendor && item.category.map((subItem,index) => {
                                            return(
                                              <span>
                                                {
                                                  subItem.sub_category.map((subProduct,index) => {
                                                    return(
                                                      <span className="mb-0">{(index ? ', ': '') + subProduct.sub_category} </span>
                                                    );
                                                  })
                                                }
                                              </span>
                                            );
                                          })
                                        }
                                      </div>
                                    </div>
                                  );
                                })
                              }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    :
                      <div className="col-lg-6">
                      <div className="e-vendor-category-list">
                        <div className="row">
                          <div className="e-new-store col-lg-12">
                            <h5 className="mb-2">Add new online store</h5>
                          </div>

                          <div className="col-lg-4">
                            <div className="e-subcategory-content ">
                              {
                                this.state.uploading ?
                                  <span className="e-upload-btn e-store e-b-list-logo-uploader text-center mb-3"></span>
                                :
                                  <React.Fragment>
                                    {
                                      this.state.logo ?
                                        <span className="e-b-list-logo">
                                          <span className="e-close-icon" onClick={(e) => this.setState({logo: null})}></span>
                                          <img src={this.state.logo}/>
                                        </span>
                                      :
                                        <span className="e-upload-btn e-store text-center mb-3" onClick={this.chooseImage.bind(this)}>Upload your online store logo</span>
                                    }
                                  </React.Fragment>
                              }
                            
                            </div>
                          </div>
                          <div className="col-lg-8">
                            <div className="e-note-wrap">
                              <p className="e-note pl-3 pt-2">*Note</p>
                              <p className="e-note-content pb-2 pl-3">Logo must be square (400px * 400px)</p>
                            </div>
                          </div>
                        </div>
                        <div className="row e-website-link">
                          <div className="col-lg-12">
                            <label className="" >Website</label>
                            <Input id="e-web" type="text" defaultValue={this.state.website} className="e-deal-link e-profile-website" valueChange={(tempVal) => this.setState({website: tempVal})} placeholder="Website link" />
                          </div>
                        </div>
                        <div className="row e-website-link">
                          <div className="col-lg-12">
                            <label className="" >Company</label>
                            <Input id="e-company" type="text" defaultValue={this.state.company} className="e-deal-link e-profile-website" valueChange={(tempVal) => this.setState({company: tempVal})} placeholder="Company Name" />
                          </div>
                        </div>
                        <div className="row e-website-link">
                          <div className="col-lg-12">
                            <label className="">Conatct Person</label>
                            <Input id="e-name" type="text" defaultValue={this.state.name} className="e-deal-link e-profile-website" valueChange={(tempVal) => this.setState({name: tempVal})} placeholder="Conatct Person" />
                          </div>
                        </div>
                        <div className="row e-website-link">
                          {
                            !this.state.localVendor?
                              <div className="col-lg-12">
                                <label className="">Locality</label>
                                <Input id="e-locality" type="text" defaultValue={this.state.locality} className="e-deal-link e-profile-website" valueChange={(tempVal) => this.setState({locality: tempVal})} placeholder="Locality"/>
                              </div>
                            :
                            null
                          }
                        </div>
                        <div className="row e-website-link">
                          <div className="col-lg-12">
                            <label>Address</label>
                            <Textarea id="e-address" defaultValue={this.state.address} type="text" className="e-deal-link e-profile-website" valueChange={(e) => {this.setState({address: e}) }}></Textarea>
                          </div>
                        </div>

                       

                        <div className="row e-online-subcategory">
                          <div className="col-lg-12 ">
                          <div className="e-border">
                            <div className="row pl-3">

                              <h5>Select online categories</h5>
                            </div>
                            
                            <div className="row">
                            {
                              this.state.categories && this.state.categories.map((item,index) => {

                                return(
                                  <div className="col-lg-4">
                                    <div className="custom-control custom-checkbox mb-3" onClick={(e)=>{ e.preventDefault(); this.subcategoryChange(item.id) } }>
                                      <input type="checkbox" checked={this.state.category_ids && this.state.category_ids.length && this.state.category_ids.indexOf(item.id)!= -1} className="custom-control-input" id={"customCheck"+item.id}/>
                                      <label className="custom-control-label pt-1 e-collections" for={"customCheck"+item.id}>{this.state.localVendor? item.name : item.category}</label>
                                    </div>
                                  </div>
                                );
                              })
                            }
                            </div>
                            {/*<div className="row">
                              <a href="#" className="e-new-category">Add New Sub-category</a>
                            </div>*/}

                            </div>
                          </div>
                        </div>


                        <div className="row e-online-subcategory pt-3">
                          <div className="col-lg-12 ">
                            <div className="e-border">
                              <div className="row pl-3">
                                <h5>Select online sub-category</h5>
                              </div>
                              {
                                this.state.subcategoryLoading ?
                                  <React.Fragment>
                                    <LazyLoaderGif/>
                                  </React.Fragment>
                                :
                                  <div className="row">
                                    {
                                      this.state.SubCategoryData && this.state.SubCategoryData.map((item,index) => {
                                        return(
                                          <div className="col-lg-4">
                                            <div className="custom-control custom-checkbox mb-3" onClick={(e)=>{ e.preventDefault(); this.productChange(item.id) } }>
                                              <input type="checkbox" checked={this.state.selectedSubCatIds && this.state.selectedSubCatIds.length? this.state.selectedSubCatIds.indexOf(item.id)!= -1: false} className="custom-control-input" id={"customCheck"+item.id}/>
                                              <label className="custom-control-label pt-1 e-collections" for={"customCheck"+item.id}>{item.sub_category}</label>
                                            </div>
                                          </div>
                                        );
                                      })
                                    }
                                  </div>
                              }
                              
                            </div>
                          </div>
                        </div>
                        {
                          this.state.productLoading ?
                            <React.Fragment>
                              <LazyLoaderGif/>
                            </React.Fragment>
                          :
                            <React.Fragment>

                              {
                                this.state.productData &&  this.state.productData.length ?
                                  <React.Fragment>
                                    <div className="row e-online-subcategory pt-3">
                                      <div className="col-lg-12 ">
                                        <div className="e-border">
                                          <div className="row pl-3">
                                            <h5>Select online products</h5>
                                          </div>

                                          <div className="row">
                                            {
                                              this.state.productData.map((item, index)=>{
                                                return(
                                                  <div className="col-lg-4">
                                                    <div className="custom-control custom-checkbox mb-3" onClick={(e)=>{this.productSelect(item.id) } }>
                                                      <input type="checkbox" className="custom-control-input" checked={this.state.selectedprod.indexOf(item.id)!= -1} />
                                                      <label className="custom-control-label pt-1 e-collections">{item.product}</label>
                                                    </div>
                                                  </div>
                                                 );
                                              })
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </React.Fragment>
                                :
                                  <div className="row e-online-subcategory pt-3">
                                    <div className="col-lg-12 ">
                                      <div className="e-border">
                                        <p className="mb-0 pb-0">No prodouct found. Select a category.</p>
                                      </div>
                                    </div>
                                  </div>
                              }
                            </React.Fragment>
                        }
                        
                        <div className="row mt-4">
                          <div className="col-lg-12">
                            {
                              this.state.company.length && 
                              this.state.website&&
                              this.state.website.length && 
                              this.state.name.length && 
                              this.state.locality.length && 
                              this.state.address.length && 
                              this.state.category_ids && this.state.category_ids.length && 
                              this.state.selectedSubCatIds.length && 
                              this.state.selectedprod.length && 
                              this.state.logo ?
                                <button className="e-s-btn" type="submit" value="Submit" onClick={this.profileCompleted.bind(this)}>Update</button>
                              :
                               <button className="e-s-btn e-inactive" type="submit" value="Submit">Update</button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  
                </div>

                 <ImageUploader
                    tempKey="/user/pan-card"
                    className="hidden"
                    style={{display: 'none'}}
                    id="e-dp-uploader"
                    accept="image/*"
                    uploadStatus={this.uploadStatus.bind(this)}
                    uploadSucess={this.uploadSucess.bind(this)}
                  />

        
              </div>

          :
            <NoDataFound head="Nothing Found" data="No Profile Found"/>
        }

        {/*Modals*/}

        {
          this.state.data ?
          <>
            <EditModal data={this.state.data}/>
            <ChangeLocationModal locationOptions={this.state.locations} 
            selectedLocation={{value: this.state.data.location_id, label: this.state.data.location}}
            updateLocation={val=>this.updateLocation(val)}/>
            </>
          :
            null
        }

        </div>
      }

      </div>
    );
  }
}

export default ProfileListing;
